import React from 'react';
import Movies from '../components/Movies/Movies';
import Nav from '../components/Nav/Nav';
import Main from '../components/Main/Main';

const Home = () => (
  <>
    <Nav />
    <Main />
    <Movies />
  </>
);

export default Home;
